require('../../shared/highcharts-config')

const Perf_chart = require('../performances/perf-chart'),
  data = {
    name: ['P1⁽³⁾ <br><small>50% €<br> 50% UC</small>', 'P2 <br><small>45% €<br> 55% UC</small>', 'P3 <br><small>40% €<br> 60% UC</small>', 'P4 <br><small>36% €<br> 64% UC</small>', 'P5 <br><small>30% €<br> 70% UC</small>', 'P6 <br><small>25% €<br> 75% UC</small>', 'P7 <br><small>20% €<br> 80% UC</small>', 'P8 <br><small>17% €<br> 83% UC</small>', 'P9 <br><small>14% €<br> 86% UC</small>', 'P10 <br><small>5% €<br> 95% UC</small>'],
    perf: [1.46, 3.38, 4.84, 5.63, 8.69, 10.42, 11.10, 11.92, 13.85, 16.32],
    vol:  [1.49, 2.14, 2.91, 3.73, 4.22,  5.32,  5.98,  6.89,  7.45,  9.05]
  }

$(function() {
  Perf_chart(data)
})
